"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3778],{

/***/ 69494:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(11720));
const RightArrow = () => {
    return (react_1.default.createElement("svg", { width: "6", height: "10", viewBox: "0 0 6 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M5.14142 4.64644C5.33668 4.8417 5.33668 5.15828 5.14142 5.35355L0.844975 9.64999C0.651675 9.84329 0.338275 9.84329 0.144975 9.64999C-0.0483248 9.45669 -0.0483247 9.14329 0.144975 8.94999L4.09497 4.99999L0.144975 1.04999C-0.0483247 0.856692 -0.048325 0.543291 0.144974 0.349992C0.338274 0.156692 0.651675 0.156692 0.844974 0.349992L5.14142 4.64644Z", fill: "#5B5675" })));
};
exports["default"] = RightArrow;
//# sourceMappingURL=RightArrow.js.map

/***/ }),

/***/ 26773:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ASSETS = void 0;
exports.ASSETS = {
    OFFER_LIGHT: 'https://travel.ackoassets.com/images/coupons/offer-light.svg',
    OFFER_DARK: 'https://travel.ackoassets.com/images/coupons/offer-dark.svg',
    CLOCK_RED: 'https://travel.ackoassets.com/images/coupons/clock-red.svg',
    CLOCK_GRAY: 'https://travel.ackoassets.com/images/coupons/clock-gray.svg',
    DROP_DOWN: 'https://travel.ackoassets.com/images/pdp_web/dropdown.svg',
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 43110:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(11720));
const assets_1 = __webpack_require__(26773);
const config_1 = __webpack_require__(23350);
const styles_1 = __webpack_require__(83765);
const RightArrow_1 = __importDefault(__webpack_require__(69494));
const ApplyCouponCard = ({ header_text = '', headerStyles = {}, coupons = [], applyCouponCallback = () => { }, removeCouponCallback = () => { }, seeAllCallback = () => { }, isLightTheme = false, }) => {
    const couponList = (coupons || []).filter((c) => !!(c === null || c === void 0 ? void 0 : c.coupon_id));
    const coupon = (couponList === null || couponList === void 0 ? void 0 : couponList[0]) || {};
    const isDarkCondition = isLightTheme ||
        !(coupon === null || coupon === void 0 ? void 0 : coupon.coupon_id) ||
        (coupon === null || coupon === void 0 ? void 0 : coupon.status) === config_1.STATUS.APPLIED ||
        (coupon === null || coupon === void 0 ? void 0 : coupon.status) === config_1.STATUS.NON_APPLICABLE;
    return (react_1.default.createElement(styles_1.CouponCardWrapper, null,
        react_1.default.createElement(styles_1.CouponHeader, { styles: headerStyles },
            react_1.default.createElement("img", { src: isDarkCondition ? assets_1.ASSETS.OFFER_DARK : assets_1.ASSETS.OFFER_LIGHT, alt: 'offer-icon', width: '22px', height: '22px' }),
            react_1.default.createElement(styles_1.HeaderText, { isDark: isDarkCondition }, header_text)),
        react_1.default.createElement(styles_1.CouponContentWrapper, null, couponList === null || couponList === void 0 ? void 0 :
            couponList.map((coupon, idx) => {
                var _a, _b;
                if ((coupon === null || coupon === void 0 ? void 0 : coupon.status) === config_1.STATUS.NON_APPLICABLE)
                    return null;
                return (react_1.default.createElement(react_1.default.Fragment, { key: coupon === null || coupon === void 0 ? void 0 : coupon.coupon_id },
                    (coupon === null || coupon === void 0 ? void 0 : coupon.status) !== config_1.STATUS.APPLIED ? (react_1.default.createElement(styles_1.CouponCTAWrapper, null,
                        react_1.default.createElement(styles_1.Text, { color: '#040222', weight: '600', size: '16px' }, (_a = coupon === null || coupon === void 0 ? void 0 : coupon.title) === null || _a === void 0 ? void 0 : _a.text),
                        react_1.default.createElement(styles_1.ApplyCTA, { onClick: () => applyCouponCallback(coupon) }, 'Apply'))) : (react_1.default.createElement(styles_1.CouponCTAWrapper, null,
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(styles_1.Text, { color: '#040222', weight: '600', size: '16px', lineHeight: '1.375rem' }, (_b = coupon === null || coupon === void 0 ? void 0 : coupon.title) === null || _b === void 0 ? void 0 : _b.text),
                            react_1.default.createElement(styles_1.Text, { color: '#0B753E', weight: '500', size: '0.75rem', lineHeight: '1rem', margin: '6px 0 0 0' }, coupon === null || coupon === void 0 ? void 0 : coupon.description)),
                        (coupon === null || coupon === void 0 ? void 0 : coupon.is_removable) === false ? null : (react_1.default.createElement(styles_1.Text, { color: '#D83D37', weight: '600', size: '0.75rem', lineHeight: '1rem', onClick: () => removeCouponCallback(coupon), style: { cursor: 'pointer', marginTop: '4px' } }, 'Remove')))),
                    idx !== couponList.length - 1 && react_1.default.createElement(styles_1.RowDivider, null)));
            }),
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(styles_1.DottedLine, null),
                react_1.default.createElement(styles_1.Text, { color: '#5B5675', weight: '500', size: '0.875rem', lineHeight: '1.25rem', margin: '12px 16px', onClick: seeAllCallback, style: { cursor: 'pointer' } },
                    `See all coupons`,
                    react_1.default.createElement(styles_1.ArrowIcon, null,
                        react_1.default.createElement(RightArrow_1.default, null)))))));
};
exports["default"] = ApplyCouponCard;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 83765:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ArrowIcon = exports.HeaderText = exports.Text = exports.DottedLine = exports.ApplyCTA = exports.RowDivider = exports.CouponContentWrapper = exports.CouponCTAWrapper = exports.CouponHeader = exports.CouponCardWrapper = void 0;
const building_blocks_ui_common_1 = __webpack_require__(79749);
exports.CouponCardWrapper = building_blocks_ui_common_1.styled.div `
  border: 1px solid #e7e7f0;
  border-radius: 12px;
  width: 100%;
  background: rgba(255, 255, 255, 1);
`;
exports.CouponHeader = building_blocks_ui_common_1.styled.div `
  color: #fff;
  border-radius: 12px 12px 0 0;
  padding: 12px 18px;
  text-align: center;
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(248, 247, 252, 1);
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  ${(props) => props && props.styles};
`;
exports.CouponCTAWrapper = building_blocks_ui_common_1.styled.div `
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding: 16px;
  padding-bottom: 12px;
`;
exports.CouponContentWrapper = building_blocks_ui_common_1.styled.div ``;
exports.RowDivider = building_blocks_ui_common_1.styled.hr `
  border: 0;
  border-top: 1px solid rgba(231, 231, 240, 1);
  margin: 0 16px;
`;
exports.ApplyCTA = building_blocks_ui_common_1.styled.div `
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 0.875rem;
  color: #040222;
  cursor: pointer;
  border-radius: 8px;
  padding: 0 12px;
  border: 1px solid #040222;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
`;
exports.DottedLine = building_blocks_ui_common_1.styled.hr `
  border: 1px;
  border-top: 1px dotted #e7e7f0;
  color: #fff;
  background-color: #fff;
  height: 1px;
  margin: 0;
`;
exports.Text = building_blocks_ui_common_1.styled.div `
  font-weight: ${(props) => (props === null || props === void 0 ? void 0 : props.weight) || '400'};
  font-size: ${(props) => `${props === null || props === void 0 ? void 0 : props.size}` || '0.875rem'};
  line-height: ${(props) => `${props === null || props === void 0 ? void 0 : props.lineHeight}` || '1.25rem'};
  color: ${(props) => (props === null || props === void 0 ? void 0 : props.color) || 'inherit'};
  margin: ${(props) => (props === null || props === void 0 ? void 0 : props.margin) || '0'};
  text-align: ${(props) => (props === null || props === void 0 ? void 0 : props.align) || ''};
  width: ${(props) => (props === null || props === void 0 ? void 0 : props.width) || 'initial'};
`;
exports.HeaderText = building_blocks_ui_common_1.styled.div `
  color: rgba(4, 2, 34, 1);
  color: ${(props) => (props === null || props === void 0 ? void 0 : props.isDark) ? 'rgba(4, 2, 34, 1)' : 'rgba(255, 255, 255, 1)'};
`;
exports.ArrowIcon = building_blocks_ui_common_1.styled.div `
  display: inline-block;
  margin-left: 8px;
`;
//# sourceMappingURL=styles.js.map

/***/ }),

/***/ 52314:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(11720));
const styles_1 = __webpack_require__(55938);
const Index = ({ coupon_list = [], activeCoupon = 1, styles = {}, onScrollCallback = () => { }, }) => {
    const [activeCount, setActiveCount] = (0, react_1.useState)(activeCoupon);
    const carousalRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (activeCount !== 1)
            onScrollCallback();
    }, [activeCount]);
    const handleScroll = () => {
        var _a, _b;
        if ((_a = carousalRef === null || carousalRef === void 0 ? void 0 : carousalRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft) {
            const count = Math.floor(((_b = carousalRef === null || carousalRef === void 0 ? void 0 : carousalRef.current) === null || _b === void 0 ? void 0 : _b.scrollLeft) / 300);
            setActiveCount(count + 1);
        }
        else
            setActiveCount(1);
    };
    return (react_1.default.createElement(styles_1.Container, { styles: styles },
        react_1.default.createElement(styles_1.Carousal, { ref: carousalRef, onScroll: () => handleScroll() }, coupon_list === null || coupon_list === void 0 ? void 0 : coupon_list.map((card) => {
            var _a, _b;
            return (react_1.default.createElement(styles_1.CardContainer, { key: card === null || card === void 0 ? void 0 : card.coupon_id },
                react_1.default.createElement(styles_1.DefaultIcon, null,
                    react_1.default.createElement("img", { src: (_a = card === null || card === void 0 ? void 0 : card.title) === null || _a === void 0 ? void 0 : _a.icon_url, width: '45px', height: '45px', alt: "offer-icon" })),
                react_1.default.createElement(styles_1.Content, null,
                    react_1.default.createElement(styles_1.Title, null, (_b = card === null || card === void 0 ? void 0 : card.title) === null || _b === void 0 ? void 0 : _b.text),
                    react_1.default.createElement(styles_1.Desc, null, card === null || card === void 0 ? void 0 : card.description))));
        })),
        (coupon_list === null || coupon_list === void 0 ? void 0 : coupon_list.length) > 1 && (react_1.default.createElement(styles_1.CountTracker, null,
            react_1.default.createElement(styles_1.Count, null, `${activeCount}/${coupon_list === null || coupon_list === void 0 ? void 0 : coupon_list.length}`),
            react_1.default.createElement(styles_1.Dots, null, coupon_list === null || coupon_list === void 0 ? void 0 : coupon_list.map((_, i) => (react_1.default.createElement(styles_1.Dot, { key: i, active: i + 1 === activeCount }))))))));
};
exports["default"] = Index;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 55938:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Dot = exports.Dots = exports.Count = exports.CountTracker = exports.ProgressInfo = exports.DefaultIcon = exports.Desc = exports.Title = exports.Content = exports.CardContainer = exports.Carousal = exports.Container = void 0;
const building_blocks_ui_common_1 = __webpack_require__(79749);
exports.Container = building_blocks_ui_common_1.styled.div `
  display: flex;
  align-items: flex-start;
  position: relative;
  max-width: ${(props) => props.maxWidth || '480px'};
  width: 100%;
  border: 1px solid rgba(231, 231, 240, 1);
  border-radius: 12px;
  cursor: default;
  ${(props) => props && props.styles};
`;
exports.Carousal = building_blocks_ui_common_1.styled.div `
  display: flex;
  align-items: flex-start;
  overflow: auto;
  position: relative;

  ::-webkit-scrollbar {
    display: none;
  }
`;
exports.CardContainer = building_blocks_ui_common_1.styled.div `
  display: flex;
  align-items: center;
  gap: 10px;
  color: #040222;
  padding: 12px 16px;
  min-width: 310px;

  @media screen and (min-width: 430px) {
    min-width: 400px;
  }
`;
exports.Content = building_blocks_ui_common_1.styled.div ``;
exports.Title = building_blocks_ui_common_1.styled.div `
  font-size: 1.125rem;
  line-height: 1.5rem;
  font-weight: 600;
  margin-bottom: 8px;
`;
exports.Desc = building_blocks_ui_common_1.styled.div `
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
`;
exports.DefaultIcon = building_blocks_ui_common_1.styled.div `
  border: 2px solid #ffffff;
  border-radius: 50%;
  height: 48px;
  min-width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;
exports.ProgressInfo = building_blocks_ui_common_1.styled.div `
  border-right: 2px solid #7c47e1;
  border-radius: 50%;
  height: 48px;
  width: 48px;
  position: absolute;
  top: -1px;
  left: -2px;
`;
exports.CountTracker = building_blocks_ui_common_1.styled.div `
  text-align: center;
  background: white;
  padding: 16px 16px 0 16px;
  border-radius: 12px;
`;
exports.Count = building_blocks_ui_common_1.styled.div `
  font-size: 0.625rem;
  font-weight: 600;
  line-height: 1.375rem;
  color: rgba(89, 32, 197, 1);
  margin-bottom: 8px;
`;
exports.Dots = building_blocks_ui_common_1.styled.div `
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
`;
exports.Dot = building_blocks_ui_common_1.styled.div `
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(89, 32, 197, 1);
  opacity: ${(props) => ((props === null || props === void 0 ? void 0 : props.active) ? '1' : '0.4')};
`;
//# sourceMappingURL=styles.js.map

/***/ }),

/***/ 26390:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(11720));
const styles_1 = __webpack_require__(70532);
const assets_1 = __webpack_require__(26773);
const config_1 = __webpack_require__(23350);
const building_blocks_ui_modal_1 = __webpack_require__(75251);
const Index = ({ isMobile = false, coupon = {}, handleApply = () => { }, handleRemove = () => { }, seeDetailsCallback = () => { }, }) => {
    var _a, _b, _c;
    const [showDetails, setShowDetails] = (0, react_1.useState)(false);
    const Modal = isMobile ? building_blocks_ui_modal_1.ModalMobile : building_blocks_ui_modal_1.ModalDesktop;
    const renderModal = () => {
        var _a, _b;
        const handleCloseModal = () => setShowDetails(false);
        return (react_1.default.createElement(Modal, { show: showDetails, onHide: handleCloseModal, wrapperStyles: `border-radius: 24px 24px 0px 0px;`, showOverlayBackground: true, urlhash: "", header: react_1.default.createElement(styles_1.ModalHeader, null, coupon === null || coupon === void 0 ? void 0 : coupon.code), padding: '32px 24px 20px 24px', minWidth: isMobile ? '' : '400px' },
            react_1.default.createElement(styles_1.TncSection, null,
                react_1.default.createElement(styles_1.TncTitle, null, 'Terms and conditions'),
                react_1.default.createElement(styles_1.TncList, null, (_b = (_a = coupon === null || coupon === void 0 ? void 0 : coupon.details) === null || _a === void 0 ? void 0 : _a.tnc) === null || _b === void 0 ? void 0 : _b.map((item) => {
                    return react_1.default.createElement(styles_1.TncItem, null, item);
                })),
                react_1.default.createElement(styles_1.ButtonContainer, { onClick: handleCloseModal },
                    react_1.default.createElement(styles_1.ButtonText, null, 'Okay')))));
    };
    return (react_1.default.createElement(styles_1.Container, null,
        react_1.default.createElement(styles_1.Header, { styles: config_1.StatusToStyleMapper[coupon === null || coupon === void 0 ? void 0 : coupon.status] },
            react_1.default.createElement(styles_1.HeaderText, { styles: config_1.StatusToStyleMapper[coupon === null || coupon === void 0 ? void 0 : coupon.status] }, (_a = coupon === null || coupon === void 0 ? void 0 : coupon.header) === null || _a === void 0 ? void 0 : _a.text)),
        react_1.default.createElement(styles_1.Content, null,
            react_1.default.createElement(styles_1.CouponData, null,
                react_1.default.createElement("img", { src: (_b = coupon === null || coupon === void 0 ? void 0 : coupon.title) === null || _b === void 0 ? void 0 : _b.icon_url, width: '18px', height: '18px', alt: "coupon-icon", style: { marginTop: '2px' } }),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(styles_1.CouponTitle, null, (_c = coupon === null || coupon === void 0 ? void 0 : coupon.title) === null || _c === void 0 ? void 0 : _c.text),
                    react_1.default.createElement(styles_1.CouponCode, { styles: config_1.StatusToStyleMapper[coupon === null || coupon === void 0 ? void 0 : coupon.status] }, coupon === null || coupon === void 0 ? void 0 : coupon.code))),
            (coupon === null || coupon === void 0 ? void 0 : coupon.status) === (config_1.STATUS === null || config_1.STATUS === void 0 ? void 0 : config_1.STATUS.APPLIED) ? ((coupon === null || coupon === void 0 ? void 0 : coupon.is_removable) === false ? null : (react_1.default.createElement(styles_1.RemoveText, { onClick: handleRemove }, 'Remove'))) : (react_1.default.createElement(styles_1.ApplyButton, { styles: config_1.StatusToStyleMapper[coupon === null || coupon === void 0 ? void 0 : coupon.status], onClick: handleApply }, 'Apply'))),
        react_1.default.createElement(styles_1.ExpirySection, { justify: (coupon === null || coupon === void 0 ? void 0 : coupon.expiry_date) ? 'space-between' : 'flex-end' },
            (coupon === null || coupon === void 0 ? void 0 : coupon.expiry_date) && (react_1.default.createElement(styles_1.ExpiryDetails, null,
                react_1.default.createElement("img", { src: assets_1.ASSETS.CLOCK_GRAY, width: '12px', height: '12px', alt: "clock-icon" }), coupon === null || coupon === void 0 ? void 0 :
                coupon.expiry_date)),
            react_1.default.createElement(styles_1.MoreDetails, { onClick: () => {
                    seeDetailsCallback();
                    setShowDetails(!showDetails);
                } },
                'See details',
                react_1.default.createElement("img", { src: assets_1.ASSETS.DROP_DOWN, width: '8px', height: '4px', alt: "dropdown-icon" }))),
        renderModal()));
};
exports["default"] = Index;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 70532:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonText = exports.ButtonContainer = exports.MoreDetails = exports.ExpiryDetails = exports.ExpirySection = exports.ApplyButton = exports.RemoveText = exports.CouponCode = exports.CouponTitle = exports.CouponData = exports.Content = exports.TncTitle = exports.TncItem = exports.TncList = exports.TncSection = exports.HeaderText = exports.Header = exports.ModalHeader = exports.Container = void 0;
const building_blocks_ui_common_1 = __webpack_require__(79749);
const building_blocks_ui_theme_1 = __webpack_require__(549);
exports.Container = building_blocks_ui_common_1.styled.div `
  width: 100%;
  position: relative;
  border-radius: 12px;
  border: 1px solid rgba(231, 231, 240, 1);
  cursor: default;
  background: rgba(255, 255, 255, 1);
`;
exports.ModalHeader = building_blocks_ui_common_1.styled.div `
  font-size: 1.125rem;
  line-height: 1.5rem;
  font-weight: 600;
`;
exports.Header = building_blocks_ui_common_1.styled.div `
  padding: 8px 16px;
  border-radius: 12px 12px 0 0;
  background: ${(props) => { var _a; return (_a = props === null || props === void 0 ? void 0 : props.styles) === null || _a === void 0 ? void 0 : _a.background; }};
`;
exports.HeaderText = building_blocks_ui_common_1.styled.div `
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  color: ${(props) => { var _a; return (_a = props === null || props === void 0 ? void 0 : props.styles) === null || _a === void 0 ? void 0 : _a.color; }};
`;
exports.TncSection = building_blocks_ui_common_1.styled.div `
  margin-top: -10px;
  color: rgba(91, 86, 117, 1);
`;
exports.TncList = building_blocks_ui_common_1.styled.ul `
  padding: 0 20px;
  margin-top: 8px;
`;
exports.TncItem = building_blocks_ui_common_1.styled.li `
  font-size: 1rem;
  line-height: 1.375rem;
  font-weight: 400;
`;
exports.TncTitle = building_blocks_ui_common_1.styled.div `
  font-size: 1rem;
  line-height: 1.375rem;
  font-weight: 500;
`;
exports.Content = building_blocks_ui_common_1.styled.div `
  display: flex;
  justify-content: space-between;
  padding: 16px;
`;
exports.CouponData = building_blocks_ui_common_1.styled.div `
  display: flex;
  gap: 8px;
`;
exports.CouponTitle = building_blocks_ui_common_1.styled.div `
  font-size: 1rem;
  line-height: 1.375rem;
  font-weight: 600;
  color: rgba(4, 2, 34, 1);
`;
exports.CouponCode = building_blocks_ui_common_1.styled.div `
  display: inline-block;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  color: ${(props) => {
    var _a;
    return ((_a = props === null || props === void 0 ? void 0 : props.styles) === null || _a === void 0 ? void 0 : _a.grayscale)
        ? 'rgba(224, 224, 232, 1)'
        : 'rgba(124, 71, 225, 1)';
}};
  padding: 4px;
  border-radius: 4px;
  border: 1px dashed
    ${(props) => {
    var _a;
    return ((_a = props === null || props === void 0 ? void 0 : props.styles) === null || _a === void 0 ? void 0 : _a.grayscale)
        ? 'rgba(224, 224, 232, 1)'
        : 'rgba(124, 71, 225, 1)';
}};
  margin-top: 8px;
`;
exports.RemoveText = building_blocks_ui_common_1.styled.div `
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  color: rgba(216, 61, 55, 1);
`;
exports.ApplyButton = building_blocks_ui_common_1.styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  line-height: 0.875rem;
  font-weight: 600;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  padding: 0 12px;
  border-radius: 8px;
  background: ${(props) => { var _a; return ((_a = props === null || props === void 0 ? void 0 : props.styles) === null || _a === void 0 ? void 0 : _a.grayscale) ? 'rgba(224, 224, 232, 1)' : 'rgba(4, 2, 34, 1)'; }};
  height: 30px;
  cursor: pointer;
`;
exports.ExpirySection = building_blocks_ui_common_1.styled.div `
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props === null || props === void 0 ? void 0 : props.justify) || 'flex-end'};
  padding: 12px 16px;
  border-top: 1px solid rgba(231, 231, 240, 1);
`;
exports.ExpiryDetails = building_blocks_ui_common_1.styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  color: rgba(91, 86, 117, 1);
  border-radius: 0 0 12px 12px;
`;
exports.MoreDetails = building_blocks_ui_common_1.styled.div `
  align-self: flex-end;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  color: rgba(4, 2, 34, 1);
  cursor: pointer;
`;
exports.ButtonContainer = building_blocks_ui_common_1.styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 100%;
  background: ${building_blocks_ui_theme_1.AckoMainTheme.colors.light.primary.g300};
  color: #ffffff;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 32px;
`;
exports.ButtonText = building_blocks_ui_common_1.styled.div `
  font-size: ${building_blocks_ui_theme_1.AckoMainTheme.typography.fonts.size.P1};
  font-weight: ${building_blocks_ui_theme_1.AckoMainTheme.typography.fonts.weight.T1};
  line-height: ${building_blocks_ui_theme_1.AckoMainTheme.typography.lineHeights.T1};

  @media only screen and (max-width: 768px) {
    line-height: ${building_blocks_ui_theme_1.AckoMainTheme.typography.lineHeights.P1};
  }
`;
//# sourceMappingURL=styles.js.map

/***/ }),

/***/ 23350:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StatusToStyleMapper = exports.STATUS = void 0;
exports.STATUS = {
    APPLICABLE: 'Applicable',
    NON_APPLICABLE: 'NonApplicable',
    APPLIED: 'Applied',
};
exports.StatusToStyleMapper = {
    Applicable: {
        background: 'linear-gradient(90deg, #EBFBEE 0%, #F0FFE5 97.82%)',
        color: 'rgba(6, 70, 37, 1)',
        grayscale: false,
    },
    NonApplicable: {
        background: 'linear-gradient(90.12deg, #FFF7E5 0.07%, #FFEBD8 137.49%)',
        color: 'rgba(209, 105, 0, 1)',
        grayscale: true,
    },
    Applied: {
        background: 'linear-gradient(90deg, #EBFBEE 0%, #F0FFE5 97.82%)',
        color: 'rgba(6, 70, 37, 1)',
        grayscale: false,
    },
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 19159:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ApplyCouponCard = exports.CouponInfoCard = exports.CouponsCarousal = void 0;
const carousal_1 = __importDefault(__webpack_require__(52314));
exports.CouponsCarousal = carousal_1.default;
const coupon_info_card_1 = __importDefault(__webpack_require__(26390));
exports.CouponInfoCard = coupon_info_card_1.default;
const apply_coupon_card_1 = __importDefault(__webpack_require__(43110));
exports.ApplyCouponCard = apply_coupon_card_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 46650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var _acko_tech_building_blocks_ui_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75251);
/* harmony import */ var _acko_tech_building_blocks_ui_modal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_acko_tech_building_blocks_ui_modal__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_common_utils_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79354);
/* harmony import */ var src_international_insurance_styles_checkout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51262);
/* harmony import */ var lottie_web__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11248);
/* harmony import */ var lottie_web__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lottie_web__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var src_international_insurance_styles_couponSuccessModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77546);







var Index = function(param) {
    var open = param.open, setOpen = param.setOpen, coupon = param.coupon, _sendEvent = param.sendEvent, sendEvent = _sendEvent === void 0 ? function() {} : _sendEvent;
    var ref, ref1;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var giftAnimation;
        var confettiAnimation;
        var topConfettiAnimation;
        var bottomConfettiAnimation;
        if (true) {
            giftAnimation = document === null || document === void 0 ? void 0 : document.getElementById("gift-animation");
            confettiAnimation = document === null || document === void 0 ? void 0 : document.getElementById("confetti-animation");
            topConfettiAnimation = document === null || document === void 0 ? void 0 : document.getElementById("top-confetti-animation");
            bottomConfettiAnimation = document === null || document === void 0 ? void 0 : document.getElementById("bottom-confetti-animation");
        }
        lottie_web__WEBPACK_IMPORTED_MODULE_5___default().loadAnimation({
            container: giftAnimation,
            renderer: "svg",
            loop: true,
            autoplay: true,
            path: src_common_utils_config__WEBPACK_IMPORTED_MODULE_3__/* .ANIMATIONS.GIFT_BOX */ .OK.GIFT_BOX || src_common_utils_config__WEBPACK_IMPORTED_MODULE_3__/* .ASSETS.GIFT_BOX */ .ou.GIFT_BOX
        });
        lottie_web__WEBPACK_IMPORTED_MODULE_5___default().loadAnimation({
            container: confettiAnimation,
            renderer: "svg",
            loop: true,
            autoplay: true,
            path: src_common_utils_config__WEBPACK_IMPORTED_MODULE_3__/* .ANIMATIONS.CONFETTI */ .OK.CONFETTI
        });
        lottie_web__WEBPACK_IMPORTED_MODULE_5___default().loadAnimation({
            container: topConfettiAnimation,
            renderer: "svg",
            loop: true,
            autoplay: true,
            path: src_common_utils_config__WEBPACK_IMPORTED_MODULE_3__/* .ANIMATIONS.CONFETTI */ .OK.CONFETTI
        });
        lottie_web__WEBPACK_IMPORTED_MODULE_5___default().loadAnimation({
            container: bottomConfettiAnimation,
            renderer: "svg",
            loop: true,
            autoplay: true,
            path: src_common_utils_config__WEBPACK_IMPORTED_MODULE_3__/* .ANIMATIONS.CONFETTI */ .OK.CONFETTI
        });
        if (!!open) sendEvent();
        return function() {
            lottie_web__WEBPACK_IMPORTED_MODULE_5___default().destroy();
        };
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_acko_tech_building_blocks_ui_modal__WEBPACK_IMPORTED_MODULE_2__.ModalDesktop, {
        show: open,
        onHide: function() {
            return setOpen(false);
        },
        urlhash: "",
        padding: "16px 28px",
        minWidth: "320px",
        hideCloseButton: true,
        minHeight: "250px",
        styles: {
            overflow: "visible",
            minHeight: "unset",
            height: "180px"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(src_international_insurance_styles_couponSuccessModal__WEBPACK_IMPORTED_MODULE_6__/* .CouponSuccessModalContainer */ .dk, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(src_international_insurance_styles_couponSuccessModal__WEBPACK_IMPORTED_MODULE_6__/* .GiftAnimation */ .Q9, {
                    id: "gift-animation"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(src_international_insurance_styles_couponSuccessModal__WEBPACK_IMPORTED_MODULE_6__/* .ConfettiAnimation */ .mf, {
                    id: "confetti-animation"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(src_international_insurance_styles_couponSuccessModal__WEBPACK_IMPORTED_MODULE_6__/* .TopConfettiAnimation */ .qn, {
                    id: "top-confetti-animation"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(src_international_insurance_styles_couponSuccessModal__WEBPACK_IMPORTED_MODULE_6__/* .BottomConfettiAnimation */ .Pt, {
                    id: "bottom-confetti-animation"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(src_international_insurance_styles_couponSuccessModal__WEBPACK_IMPORTED_MODULE_6__/* .GradientText */ .t1, {
                    children: (coupon === null || coupon === void 0 ? void 0 : coupon.discount) ? "".concat(coupon === null || coupon === void 0 ? void 0 : (ref = coupon.discount) === null || ref === void 0 ? void 0 : ref.unit, " ").concat(coupon === null || coupon === void 0 ? void 0 : (ref1 = coupon.discount) === null || ref1 === void 0 ? void 0 : ref1.value, " off") : coupon === null || coupon === void 0 ? void 0 : coupon.code
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(src_international_insurance_styles_checkout__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                    color: "rgb(91, 86, 117)",
                    size: "0.75rem",
                    weight: "400",
                    lineHeight: "1rem",
                    margin: "8px 0 0 0",
                    children: "on your premium"
                }),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(src_international_insurance_styles_checkout__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                    color: "rgb(4, 2, 34)",
                    size: "0.875rem",
                    weight: "600",
                    margin: "16px 0 0 0",
                    lineHeight: "1.5rem",
                    children: "".concat((coupon === null || coupon === void 0 ? void 0 : coupon.discount) ? "'".concat(coupon === null || coupon === void 0 ? void 0 : coupon.code, "' ") : "", "coupon applied")
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Index);


/***/ }),

/***/ 51262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bp": function() { return /* binding */ FooterContent; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "Fh": function() { return /* binding */ SkeletonContainer; },
/* harmony export */   "HD": function() { return /* binding */ DisclaimerIcon; },
/* harmony export */   "MA": function() { return /* binding */ TnC; },
/* harmony export */   "Qd": function() { return /* binding */ AccordionItem; },
/* harmony export */   "RQ": function() { return /* binding */ InlineText; },
/* harmony export */   "UQ": function() { return /* binding */ Accordion; },
/* harmony export */   "Uk": function() { return /* binding */ AccordionDropdown; },
/* harmony export */   "Vb": function() { return /* binding */ DisclaimerKnowMore; },
/* harmony export */   "X2": function() { return /* binding */ Row; },
/* harmony export */   "YH": function() { return /* binding */ DisclaimerLine; },
/* harmony export */   "sg": function() { return /* binding */ Column; },
/* harmony export */   "sj": function() { return /* binding */ AccordionHead; },
/* harmony export */   "vF": function() { return /* binding */ AccordionContent; },
/* harmony export */   "vp": function() { return /* binding */ DisclaimerCardContainer; },
/* harmony export */   "xG": function() { return /* binding */ DisclaimerText; },
/* harmony export */   "xv": function() { return /* binding */ Text; },
/* harmony export */   "y$": function() { return /* binding */ Highlight; }
/* harmony export */ });
/* unused harmony exports PerPerson, Overview, ButtonContainer */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79749);
/* harmony import */ var _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 700;\n  font-size: 1.625rem;\n  line-height: 2.25rem;\n  padding: 0 0 24px 0;\n\n  @media screen and (min-width: 768px) {\n    max-width: 560px;\n    color: #040222;\n    margin: 32px auto 32px auto;\n    padding-bottom: 0;\n    font-size: 2rem;\n    line-height: 2.5rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media screen and (min-width: 768px) {\n    max-width: 560px;\n    margin: auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline;\n  color: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media screen and (min-width: 768px) {\n    max-width: 560px;\n    margin: auto;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: ",
        ";\n  border-radius: 12px;\n  margin-bottom: 16px;\n  cursor: pointer;\n\n  @media screen and (min-width: 768px) {\n    background: #ffffff;\n    box-shadow: 0px 4px 4px -2px #36354c0f;\n    border: 1px solid #e7e7f0;\n    margin-bottom: 32px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: ",
        ";\n  justify-content: ",
        ";\n  margin: ",
        ";\n  gap: 12px;\n  position: relative;\n  padding-bottom: unset;\n  width: 100%;\n\n  @media screen and (min-width: 768px) {\n    background: #efe9fb;\n    padding: 16px 20px;\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: ",
        ";\n  opacity: ",
        ";\n  overflow: hidden;\n  transition: all 0.25s ease-in;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  right: 0;\n  transition: all 0.3s ease-in;\n  transform: ",
        ";\n\n  @media screen and (min-width: 768px) {\n    right: 20px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: ",
        ";\n  justify-content: ",
        ";\n  padding: 0 20px 16px 20px;\n  text-align: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  margin: ",
        ";\n  text-align: ",
        ";\n  width: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: ",
        ";\n  justify-content: ",
        ";\n  flex-direction: column;\n  background: #f8f7fc;\n  border-radius: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 600;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  display: inline-block;\n  color: #5b5675;\n  margin-left: 4px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  color: ",
        ";\n  padding: 4px 0 0 30px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  color: #5b5675;\n  display: inline;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: inherit;\n  padding-bottom: 24px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 0.75rem;\n  line-height: 1rem;\n  font-weight: 400;\n  margin-top: 16px;\n  margin-right: 10px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-bottom: 16px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  background: #e2f5ff;\n  border-radius: 12px;\n  padding: 12px;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  font-weight: 400;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  color: #5b5675;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n  line-height: inherit;\n  display: inline;\n  color: #054599;\n  text-decoration: underline;\n  cursor: pointer;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 0 0 16px;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1px;\n  @media screen and (max-width: 768px) {\n    margin-top: 2px;\n  }\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}

var Title = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject());
var FooterContent = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject1());
var Highlight = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject2(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.color) || "#7c47e1";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) || "inherit";
});
var Accordion = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject3());
var AccordionItem = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject4(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.open) ? "1px solid #e7e7f0" : "unset";
});
var AccordionHead = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject5(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.align) || "flex-start";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.justify) || "flex-start";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.margin) || "0";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.radius) || "12px 12px 0 0";
});
var AccordionContent = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject6(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.open) ? "unset" : "0";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.open) ? "1" : "0";
});
var AccordionDropdown = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject7(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.rotate) ? "rotate(180deg)" : "rotate(0deg)";
});
var Row = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject8(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.align) || "flex-start";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.justify) || "space-between";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.textAlign) || "";
});
var Text = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject9(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.weight) || "400";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) || "0.875rem";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.lineHeight) || "1.25rem";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.color) || "inherit";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.margin) || "0";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.align) || "";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.width) || "initial";
});
var Column = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject10(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.align) || "flex-start";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.justify) || "flex-start";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.radius) || "12px 12px 0 0";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.padding) || " 16px 20px";
});
var PerPerson = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject11());
var Overview = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject12(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.weight) || "400";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.color) || "#5B5675";
});
var InlineText = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject13());
var ButtonContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject14());
var TnC = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject15());
var SkeletonContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject16());
var DisclaimerCardContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject17());
var DisclaimerText = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject18());
var DisclaimerKnowMore = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.button(_templateObject19());
var DisclaimerLine = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject20());
var DisclaimerIcon = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject21());


/***/ }),

/***/ 77546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pt": function() { return /* binding */ BottomConfettiAnimation; },
/* harmony export */   "Q9": function() { return /* binding */ GiftAnimation; },
/* harmony export */   "dk": function() { return /* binding */ CouponSuccessModalContainer; },
/* harmony export */   "mf": function() { return /* binding */ ConfettiAnimation; },
/* harmony export */   "qn": function() { return /* binding */ TopConfettiAnimation; },
/* harmony export */   "t1": function() { return /* binding */ GradientText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79749);
/* harmony import */ var _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  position: relative;\n  top: -70px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: linear-gradient(90.97deg, #6136d9 11.34%, #d331b8 77.76%);\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-size: 2rem;\n  font-weight: 700;\n  line-height: 2.5rem;\n  margin: 20px 0 0 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  height: 80px;\n  width: 80px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  height: 240px;\n  width: 240px;\n  top: 60%;\n  left: 60%;\n  transform: translate(-50%, -50%);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  height: 240px;\n  width: 100%;\n  top: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  height: 240px;\n  width: 100%;\n  top: 400px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var CouponSuccessModalContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject());
var GradientText = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject1());
var GiftAnimation = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject2());
var ConfettiAnimation = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject3());
var TopConfettiAnimation = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject4());
var BottomConfettiAnimation = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject5());


/***/ })

}]);